import React, { type ReactNode } from 'react';

function sanitizeHttpUrl(value: string): string | null {
  try {
    const trimmed = value.trim();
    const parsed = new URL(trimmed);

    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      return parsed.toString();
    }
  } catch {
    return null;
  }

  return null;
}

export function parseTextWithURL(text = ''): ReactNode[] {
  const urlRegex =
    /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,6}(\/[-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi;
  const parts = text.split(' ');
  return parts.map((part: string, index: number) => {
    if (urlRegex.test(part)) {
      const sanitizedUrl = sanitizeHttpUrl(part);
      if (sanitizedUrl) {
        return (
          <a
            key={index}
            href={sanitizedUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {part}
          </a>
        );
      }
    }
    return `${part} `;
  });
}
